import { Loader } from '@skoda/k2tools-app-components';
import * as React from 'react';
import { FunctionComponent, useEffect, useState } from 'react';
import { ServicesCollection, ServicesContext } from '../../contexts/servicesContext';
import { makeStyles } from 'tss-react/mui';

type ServicesProviderProps = {
	services: ServicesCollection;
	isWidget?: boolean;
};

const useStyles = makeStyles()(() => ({
	loader: {
		'&.widget': {
			position: 'absolute'
		}
	}
}));

export const ServicesProvider: FunctionComponent<ServicesProviderProps> = ({ services, children, isWidget }) => {
	const [servicesLoaded, setServicesLoaded] = useState(false);
	const { classes: styles, cx } = useStyles();

	useEffect(() => {
		Promise.all([
			services.resourceProvider.loadResources(),
			services.settingsService.load()])
			.then(x => setServicesLoaded(true))
	}, [services]);

	return servicesLoaded
		? <ServicesContext.Provider value={services}>{children}</ServicesContext.Provider>
		: <Loader classes={{ root: cx(styles.loader, isWidget && 'widget') }} />;
};
